export default "__VITE_PUBLIC_ASSET__e3f6ad75__"